import React from 'react'
import {reset} from '../../store'
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton'

class SettingsComponent extends React.Component {
  resetGame = () => {
    reset()
    this.close()
  }
  close = () => {
    this.props.handleClose()
  }
  render(){
    const actions = [
      <FlatButton
          label="Non"
          onTouchTap={this.close}
      />,
      <FlatButton
          label="Nouvelle partie"
          primary={true}
          onTouchTap={this.resetGame}
      />,
    ]
    return (<Dialog
        title="Nouvelle partie ?"
        actions={actions}
        modal={false}
        open={this.props.open}
        onRequestClose={this.close} />)
  }
}

export default SettingsComponent;


// WEBPACK FOOTER //
// ./src/layout/dialogs/ResetComponent.js